import { combineReducers } from "redux"

import graphs from "./graphs/reducers"
import permissions from "./permissions/reducers"

const analyticsReducer = combineReducers({ graphs, permissions })

export default analyticsReducer
